import { render, staticRenderFns } from "./CAAG1030.vue?vue&type=template&id=47e2f04e&scoped=true"
import script from "./CAAG1030Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAAG1030Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CAAG1030.vue?vue&type=style&index=0&id=47e2f04e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e2f04e",
  null
  
)

export default component.exports